import { X } from 'lucide-react';
import { useEffect } from 'react';

export default function Modal({ content, onClose }) {
  useEffect(() => {
    if (content) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => { document.body.style.overflow = 'unset'; };
  }, [content]);

  if (!content) return null;

  const renderContent = () => {
    if (content === 'terms') {
      return (
        <div className="animate-in slide-in-from-bottom-4 duration-500">
          <h2 className="text-3xl font-extrabold text-slate-900 dark:text-white mb-8 border-b border-[#e00000]/30 pb-4 inline-block transition-colors">الشروط والأحكام</h2>
          <div className="space-y-6 text-slate-600 dark:text-zinc-300 leading-relaxed custom-scrollbar pr-4 pl-2 font-medium transition-colors">
            <div>
              <h3 className="text-xl font-bold text-primary-600 dark:text-primary-500 mb-2 transition-colors">1. الحضور والالتزام</h3>
              <p>يجب على المتدرب الالتزام بمشاهدة الدروس وتسليم التكاليف الأسبوعية في موعدها لضمان التقييم المستمر والاستفادة الكاملة من تجربة "العميل الافتراضي".</p>
            </div>
            <div>
              <h3 className="text-xl font-bold text-primary-600 dark:text-primary-500 mb-2 transition-colors">2. الملكية الفكرية</h3>
              <p>جميع المواد التعليمية، الفيديوهات، والملحقات هي ملكية حصرية لـ "لباب سكول" ولا يحق مشاركتها، توزيعها، أو إعادة بيعها تحت أي ظرف. يعرضك ذلك للمساءلة القانونية.</p>
            </div>
            <div>
              <h3 className="text-xl font-bold text-primary-600 dark:text-primary-500 mb-2 transition-colors">3. سياسة الاسترداد</h3>
              <p>نظراً لطبيعة المنتجات الرقمية والتفاعلية في الدورة، لا يمكن استرداد الرسوم بمجرد بدء البرنامج التدريبي ووصول المتدرب لمنصة المواد التعليمية.</p>
            </div>
          </div>
        </div>
      );
    }
    if (content === 'privacy') {
      return (
        <div className="animate-in slide-in-from-bottom-4 duration-500">
          <h2 className="text-3xl font-extrabold text-slate-900 dark:text-white mb-8 border-b border-[#e00000]/30 pb-4 inline-block transition-colors">سياسة الخصوصية</h2>
          <div className="space-y-6 text-slate-600 dark:text-zinc-300 leading-relaxed custom-scrollbar pr-4 pl-2 font-medium transition-colors">
            <div>
              <h3 className="text-xl font-bold text-primary-600 dark:text-primary-500 mb-2 transition-colors">1. جمع البيانات</h3>
              <p>نحن نستخدم قواعد بيانات <span className="text-slate-900 dark:text-white font-bold transition-colors">مشفرة تماماً</span> وآمنة لجمع بياناتك الأساسية (الاسم، رقم الواتساب، ومستواك الحالي في التصميم) بغرض التواصل السريع وإتمام عملية التسجيل بنجاح.</p>
            </div>
            <div>
              <h3 className="text-xl font-bold text-primary-600 dark:text-primary-500 mb-2 transition-colors">2. حماية المعلومات</h3>
              <p>جميع البيانات المدخلة في النموذج يتم حفظها بسرية تامة وتشفير عالي. نحن في "لباب سكول" نلتزم بعدم بيع أو مشاركة رقم هاتفك أو اسمك مع أي أطراف ثالثة لأغراض تسويقية أو دعائية.</p>
            </div>
            <div>
              <h3 className="text-xl font-bold text-primary-600 dark:text-primary-500 mb-2 transition-colors">3. استخدام البيانات</h3>
              <p>نستخدم بياناتك حصرياً لإعلامك بتفاصيل الدورة (الرسوم، المواعيد)، الرد على استفساراتك، وتقديم محتوى أكاديمي احترافي يتناسب ومستوى خبرتك الفعلي.</p>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 md:p-6" dir="rtl">
      {/* Overlay Backdrop - explicitly works for light / dark modes */}
      <div
        className="absolute inset-0 bg-slate-900/60 dark:bg-zinc-950/90 backdrop-blur-xl animate-in fade-in duration-300 transition-colors"
        onClick={onClose}
      ></div>

      {/* Modal Box */}
      <div className="relative w-full max-w-3xl bg-white dark:bg-zinc-900 border border-t-[3px] border-slate-200 dark:border-white/5 border-t-[#e00000] dark:border-t-[#e00000] rounded-lg p-8 md:p-12 shadow-[0_10px_50px_rgba(0,0,0,0.1)] dark:shadow-[0_0_50px_rgba(224,0,0,0.15)] animate-in zoom-in-95 duration-500 flex flex-col max-h-[85vh] transition-colors">
        <button
          onClick={onClose}
          className="absolute top-6 left-6 p-2.5 bg-slate-100 dark:bg-white/5 border border-slate-200 dark:border-white/10 rounded-full text-slate-500 dark:text-zinc-400 hover:text-white dark:hover:text-white hover:bg-[#e00000] dark:hover:bg-[#e00000] hover:border-[#e00000] dark:hover:border-[#e00000] hover:shadow-[0_0_20px_rgba(224,0,0,0.4)] dark:hover:shadow-[0_0_20px_rgba(224,0,0,0.6)] transition-all duration-300 z-10 group"
          aria-label="إغلاق"
        >
          <X className="w-5 h-5 group-hover:rotate-90 transition-transform duration-300" />
        </button>

        <div className="flex-1 overflow-y-auto overflow-x-hidden relative mt-2">
          {renderContent()}
        </div>
      </div>
    </div>
  );
}
